import { useEffect, useRef } from "react";

export const useTooltipPositioning = (value) => {
  const previewContainerRef = useRef(null);

  useEffect(() => {
    const currentPreview = previewContainerRef.current;
    if (!currentPreview) return;

    const positionTooltips = () => {
      const container = currentPreview;
      if (!container) return;

      const tooltips = container.querySelectorAll(
        ".variable-tooltip, .fragment-tooltip"
      );

      tooltips.forEach((tooltip) => {
        tooltip.style.left = "10px";
        tooltip.style.transform = "none";
        tooltip.style.bottom = "";
        tooltip.style.top = "";

        const containerRect = container.getBoundingClientRect();
        const parentRect = tooltip.parentElement.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();

        if (tooltipRect.right > containerRect.right) {
          const rightOverflow = tooltipRect.right - containerRect.right;
          const newLeft = parseInt(tooltip.style.left) - rightOverflow - 10;
          tooltip.style.left = `${Math.max(10, newLeft)}px`;
        }

        if (parentRect.top < containerRect.top + 40) {
          tooltip.style.top = "100%";
          tooltip.style.bottom = "auto";
          tooltip.style.marginTop = "5px";
        } else {
          tooltip.style.bottom = "100%";
          tooltip.style.top = "auto";
          tooltip.style.marginBottom = "5px";
        }
      });
    };

    setTimeout(positionTooltips, 100);
    window.addEventListener("resize", positionTooltips);
    currentPreview.addEventListener("scroll", positionTooltips);

    currentPreview.addEventListener("mouseover", (e) => {
      if (
        e.target.classList.contains("variable-highlight") ||
        e.target.closest(".fragment-block")
      ) {
        setTimeout(positionTooltips, 10);
      }
    });

    return () => {
      window.removeEventListener("resize", positionTooltips);
      if (currentPreview) {
        currentPreview.removeEventListener("scroll", positionTooltips);
      }
    };
  }, [value]);

  return { previewContainerRef };
};
